import React from "react";
import { motion } from "framer-motion";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const RZ_LOGO = "https://customer-assets.emergentagent.com/job_safety-courses-3/artifacts/hmocjdk7_logo%20RZ.png";
const SM_LOGO = "/photos/semplicemente-logo.png";

const NAV = [
  { to: "/", label: "Formazione Obbligatoria", end: true },
  { to: "/semplicemente", label: "SempliceMente" },
  { to: "/eventi", label: "Eventi & Webinar" },
  { to: "/docenti", label: "Docenti" },
  { to: "/gallery", label: "Gallery" },
];

export const Header = ({ onBook }) => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const goContatti = () => {
    setOpen(false);
    const el = document.getElementById("contatti");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else { navigate("/"); setTimeout(() => document.getElementById("contatti")?.scrollIntoView({ behavior: "smooth" }), 200); }
  };

  const linkClass = ({ isActive }) =>
    `text-sm font-600 transition-colors ${isActive ? "text-[#EA6A0A]" : "text-gray-500 hover:text-[#EA6A0A]"}`;

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 backdrop-blur-2xl bg-white/75 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3 shrink-0">
            <img src={RZ_LOGO} alt="Rischio Zero" className="h-9 sm:h-11 object-contain" data-testid="logo-rz" />
            <span className="w-px h-7 bg-gray-200 hidden sm:block" />
            <img src={SM_LOGO} alt="SempliceMente" className="h-8 sm:h-10 object-contain hidden sm:block" data-testid="logo-sm" />
          </Link>

          <nav className="hidden lg:flex items-center gap-6">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`} className={linkClass}>
                {n.label}
              </NavLink>
            ))}
            <button data-testid="nav-contatti" onClick={goContatti} className="text-sm font-600 text-gray-500 hover:text-[#EA6A0A] transition-colors">Contatti</button>
          </nav>

          <div className="flex items-center gap-2">
            <button data-testid="header-book-btn" onClick={onBook} className="hidden sm:inline-flex items-center px-5 py-2.5 rounded-full bg-[#EA6A0A] text-white text-sm font-600 shadow-[0_4px_14px_0_rgba(234,106,10,0.3)] hover:bg-[#C8590A] hover:scale-[1.03] transition-all">
              Prenota un corso
            </button>
            <button data-testid="mobile-menu-toggle" className="lg:hidden p-2 text-[#EA6A0A]" onClick={() => setOpen((v) => !v)}>
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="lg:hidden border-t border-gray-100 bg-white px-4 py-4 flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`nav-mobile-${n.to === "/" ? "home" : n.to.slice(1)}`}
              className={({ isActive }) => `text-left py-2.5 px-2 rounded-lg font-600 ${isActive ? "text-[#EA6A0A] bg-orange-50" : "text-gray-700 hover:bg-gray-50"}`}>
              {n.label}
            </NavLink>
          ))}
          <button data-testid="nav-mobile-contatti" onClick={goContatti} className="text-left py-2.5 px-2 rounded-lg text-gray-700 font-600 hover:bg-gray-50">Contatti</button>
          <button data-testid="mobile-book-btn" onClick={() => { setOpen(false); onBook(); }} className="mt-2 py-3 rounded-full bg-[#EA6A0A] text-white font-600">Prenota un corso</button>
        </motion.div>
      )}
    </header>
  );
};
